import { useParseTime } from '@/hooks'
import { defaultAuthenticSoftUsageMonthRangeStrings } from './default-month-range'

/** 明细弹窗未传有效日期时：默认最近一个月至今天（与 `useParseTime` 日界一致） */
export function defaultInstalledDetailDateRange (): [Date, Date] {
  const r = defaultAuthenticSoftUsageMonthRangeStrings()
  const [s, e] = useParseTime(r)
  if (s == null || e == null) return [new Date(), new Date()]
  return [new Date(s * 1000), new Date(e * 1000)]
}

export function resolveInstalledDetailDateRange (date?: any[]): [Date, Date] {
  if (date && date.length >= 2 && date[0] != null && date[1] != null) {
    const a = date[0] instanceof Date ? date[0] : new Date(date[0])
    const b = date[1] instanceof Date ? date[1] : new Date(date[1])
    if (!Number.isNaN(a.getTime()) && !Number.isNaN(b.getTime())) {
      return [a, b]
    }
  }
  return defaultInstalledDetailDateRange()
}
